import React from 'react';
import { Grid, Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Header from '../../../../common/Heading/head';
import { viewport } from '../../../../common/Helpers/index';

const RowHeading = styled(Row)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

const ColHeading = styled(Col)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

const Heading = (props) => {
  const { heading, eidHeading, creditReviewSuccessResponse, creditStatus } = props;
  const type = viewport();
  const isEid = creditReviewSuccessResponse?.eidQuestionnaire?.numOfQuestions > 0 || creditStatus?.eidQuestionnaire?.numOfQuestions > 0;
  const headingMessage = isEid ? eidHeading : heading;

  return (
    <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
      <RowHeading>
        <ColHeading>
          <Header heading={headingMessage} width={type === 'mobile' ? '341px' : '816px'} />
        </ColHeading>
      </RowHeading>
    </Grid>
  );
};

Heading.propTypes = {
  heading: PropTypes.string,
  eidHeading: PropTypes.string,
  creditReviewSuccessResponse: PropTypes.object,
  creditStatus: PropTypes.object,
};

export default React.memo(Heading);
